var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWelmarket = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF7A14",
  d: "m13.65 7.413-.454 2.771-2.046 1.998-2.754.414L5.69 12.1l-2.069-1.93-.798-2.757.939-2.675 1.927-2.013 2.707-.717 2.741.657 1.95 2.04.562 2.708Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF7A14",
  d: "M17.645 17.483h-3.61l-3.59.076-3.613-.074-.116-3.612.275-3.591-.004-3.459 3.457-.08 3.592-.103 3.709-.067-.286 3.709.107 3.591z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF7A14",
  d: "m21.371 11.47-3.486.021-3.591.026-3.61-.176.09 3.608-.133 3.592.07 3.583 3.342.195 3.317-.277 2.065-1.952 2.05-2.028-.197-3.35z"
})));
export default SvgWelmarket;